module.exports = __webpack_public_path__ + "static/media/logo-no-tag.140bc498.svg";